import moment from 'moment';

const ScheduleSundayField = ({HorarioDomingo}:any) => {
    const dateSplit = HorarioDomingo ? HorarioDomingo.split(' - ') : null;
    return (
        <div>
            <label>{ dateSplit ? moment(dateSplit[0]).format('hh:mm A') +" - "+moment(dateSplit[1]).format('hh:mm A') : ''}</label>
        </div>
    )
}

export default ScheduleSundayField
